import { useParams } from 'react-router-dom';

import { LoanEstimate } from '@/components/LoanEstimate/LoanEstimate';

export const LoanEstimatePage = () => {
  const { productId } = useParams();

  if (!productId) return null;

  return <LoanEstimate productId={productId} />;
};
